import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Row} from "reactstrap";
import {RotateCircleLoading} from "react-loadingg";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import {student_strings} from "../../translations/student_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import StudentApiService from "../../api/student-api-service";
import {common_strings} from "../../translations/common_translations";
import ClientTableRow from "../Tables/ClientTableRow";
import dateHelpers from "../../helpers/DateHelper";
import placeholderHelper from "../../helpers/PlaceholderHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class StudentPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: this.props.clientId,
            clientData: null,
            isLoading: false
        };
    }

    showReminder = this.showReminder.bind(this);

    componentDidMount() {
        if (this.props.clientId) {
            this.getClientData()
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.clientId !== this.state.clientId) {
            this.setState({
                clientId: nextProps.clientId,
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clientId !== this.state.clientId) {
            this.getClientData()
        }
    }

    render() {
        this.localize();

        return (
            <Card className="card-profile shadow">
                <Row className="justify-content-center">
                    <Col className="order-lg-2" lg="3">
                        <div className="card-profile-image">
                            <a href="#" onClick={e => this.props.goToClientProfile(e, this.state.clientData.id)}>

                                {!this.state.blob && this.state.clientData && this.state.clientData.photo ? (
                                    <img
                                        alt="..."
                                        style={{objectFit: "cover", imageOrientation: "from-image", transform: null}}
                                        src={this.state.clientData.photo}
                                    />
                                ) : (
                                    <img
                                        alt="..."
                                        className="rounded-circle"
                                        style={{objectFit: "cover", imageOrientation: "from-image", transform: null}}
                                        src={placeholderHelper.randomIcon()}
                                    />
                                )
                                }

                                {this.state.blob &&
                                <img
                                    alt="..."
                                    className="rounded-circle"
                                    src={this.state.blob}
                                />
                                }
                            </a>
                        </div>
                        {this.state.isLoading &&
                        <RotateCircleLoading color="white"/>
                        }
                    </Col>
                </Row>
                <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                    <div className="d-flex justify-content-between">
                        <Button
                            className="mr-4"
                            color="default"
                            size="sm"
                            onClick={e => this.props.goToClientProfile(e, this.state.clientData.id)}
                        >
                            {commonStrings.view_profile}
                        </Button>

                        <Button
                          className="float-right"
                          color="warning"
                          onClick={e => this.props.closeClientPreview(e)}
                          size="sm"
                        >
                            {commonStrings.close}
                        </Button>
                    </div>
                </CardHeader>
                <CardBody className="pt-0 pt-md-4">

                    <div className="text-center mt-5">
                        {this.state.clientData && this.state.clientData.name &&
                        <h3>
                            {this.state.clientData.name}
                        </h3>
                        }
                        <div className="h6">
                            {this.state.clientData && this.state.clientData.email ? this.state.clientData.email || "" : ""}
                        </div>

                        <div className="h5 mt-4">
                            <p className="text-danger">
                                {this.state.clientData && this.state.clientData.inj ? this.state.clientData.inj : ""}
                            </p>
                        </div>
                        {this.hasReminders() &&
                        <div className="h6">
                            <hr className="my-4"/>

                            {studentStrings.reminder_info}
                            <Col>
                                {this.renderReminders()}
                            </Col>
                        </div>
                        }
                        <hr className="my-4"/>
                        {this.state.clientData && this.state.clientData.note ?
                            (<p>
                                {this.state.clientData.note}
                            </p>) :
                            (<p>
                                {/*Note is not set*/}
                            </p>)
                        }
                        {/*<a href="#pablo" onClick={e => e.preventDefault()}>*/}
                        {/*    Show more*/}
                        {/*</a>*/}
                    </div>
                </CardBody>
            </Card>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    }

    getClientData() {
        this.setState({isLoading: true});

        StudentApiService.clientData(this.state.clientId)
            .then(res => {
                this.setState({
                    clientData: res,
                    isLoading: false
                });

            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    }

    showReminder(ev, reminder) {
        ev.preventDefault();
        this.props.showReminder(reminder)
    }

    renderReminders() {
        if (this.state.clientData && this.state.clientData.reminders) {
            return this.state.clientData.reminders.map((reminder, index) => {
                if (reminder.yclass_id && this.state.clientData.yclass_data && this.classDataExists(reminder)) {
                    return (
                        <Button
                            key={reminder.id}
                            style={{marginTop: 4, width: "100%"}}
                            className="mr-4"
                            color="danger"
                            outline="button"
                            onClick={e => this.showReminder(e, reminder)}
                            size="lg"
                        >
                            <div className="text-center">
                                <small>
                                    {this.reminderData(reminder)[1]}
                                </small>
                            </div>

                            <div className="text-center" style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                                {this.reminderData(reminder)[0]}
                            </div>
                        </Button>
                    )
                } else return null
            })
        }
    }

    hasReminders() {
        return this.state.clientData
            && this.state.clientData.reminders
            && this.state.clientData.reminders.length > 0
            && this.state.clientData.yclass_data
            && this.state.clientData.yclass_data.length > 0
    }

    reminderData(reminder) {
        const classInfo = this.state.clientData.yclass_data.find(it => it.id === reminder.yclass_id);
        return [classInfo.name, dateHelpers.formatDate(new Date(classInfo.date))]
    }

    classDataExists(reminder) {
        return this.state.clientData.yclass_data.find(it => it.id === reminder.yclass_id);
    }
}

StudentPreview.propTypes = propTypes;

export default StudentPreview;